import { FC, memo, useCallback } from "react";
import { CopyIcon } from "lucide-react";
import { showToast } from "@utils/showToast";
const ContractAddress: FC<{ contract: string }> = memo(({ contract }) => {
    const handleCopy = useCallback(async () => {
        await navigator.clipboard.writeText(contract);
        showToast("Successfully copied to the clipboard", "success");
    }, [contract]);

    return (
        <div className="flex items-center justify-start gap-2">
            <span className=" border-opacity-50">
                {contract.slice(0, 4)}...{contract.slice(-4)}
            </span>
            <CopyIcon className="w-4 h-4 text-gray-400 cursor-pointer" onClick={handleCopy} />
        </div>
    );
});

ContractAddress.displayName = "ContractAddress";

export default ContractAddress;
